export const boardFrameClipPath = (frame) => {
  if (!frame?.width || !frame?.height) {
    return undefined;
  }

  const right = Math.max(
    0,
    (frame.overlayWidth ?? 0) - frame.left - frame.width
  );
  const bottom = Math.max(
    0,
    (frame.overlayHeight ?? 0) - frame.top - frame.height
  );

  return `inset(${frame.top}px ${right}px ${bottom}px ${frame.left}px)`;
};
